import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
//import { useTranslation } from 'react-i18next';
import OrderDetailInfoTable from './OrderDetail/OrderDetailInfoTable';
import {GetOrderArticleInfoForOrderInfoTable} from '../../Helpers/OrderInfoHelper'

export default function OrderInfo(props) {
    const classes = useStyles();
    //const { t } = useTranslation();   

    return <div className={classes.orderInfo}>
        <div className={classes.orderno}>
            Ordern°
        </div>
        <div className={classes.orderNumber}>
            {props.productionOrder.reference}
        </div>
        <div className={classes.orderTable}>
        </div>
        <OrderDetailInfoTable rows = {GetOrderArticleInfoForOrderInfoTable(props.productionOrder.bomOut[0])}></OrderDetailInfoTable>
    </div>
}

const useStyles = makeStyles({
    orderInfo: {
        height: "150px",
        float: "left",
        paddingLeft: "40px",
        width:"44%",
        boxSizing:"border-box"
    },
    orderno: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        display: "block",
        marginTop: "15px"
    },
    orderNumber: {
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        display: "block",
        marginBottom:"10px"
    },
    orderTable:{
        display:"block"
    },
    nameCell:{
        padding:"3px !important",
        border:"none",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        width:"100px"
    },
    infoCell:{
        padding:"3px !important",
        border:"none",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",    
    },
    paper:{
        boxShadow:'none'
    },
    row:{
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
          },
    }
});